import type {ContentBlocksFragment} from '@/modules/foundation/sanity/content-blocks/query';
import {BLOCK_TYPE_TEXT} from '@/modules/page/sanity/content-blocks/text-container/constants';
import {TEXT_SECTION_FRAGMENT} from '@/modules/page/sanity/content-blocks/text-container/query';
import {BLOCK_TYPE_PERSON_LIST_SELECTION} from '@/modules/person/sanity/person-list-selection-container/constants';
import {PERSON_LIST_SELECTION_FRAGMENT} from '@/modules/person/sanity/person-list-selection-container/query';

import type {BLOCK_TYPE_COLLAPSIBLE_CONTENT} from './constants';

export const CONTENT_BLOCK_IN_COLLAPSIBLE_FRAGMENT = `//groq
	...,

	// Klart foundation
	_type == "${BLOCK_TYPE_TEXT}" => {
		${TEXT_SECTION_FRAGMENT}
	},

	// Person extension
	_type == "${BLOCK_TYPE_PERSON_LIST_SELECTION}" => {
		${PERSON_LIST_SELECTION_FRAGMENT}
	},
`;

export type CollapsibleContentFragment = Extract<
	ContentBlocksFragment[number],
	{_type: typeof BLOCK_TYPE_COLLAPSIBLE_CONTENT}
>;

export type ContentBlockInCollapsibleFragment = NonNullable<
	CollapsibleContentFragment['content']
>[number];

export const COLLAPSIBLE_CONTENT_FRAGMENT = `//groq
	...,
	content[]{
		${CONTENT_BLOCK_IN_COLLAPSIBLE_FRAGMENT}
	},
`;
